import * as types from './mutation-types';
const mutations = {
  [types.SET_USERINFO](state, status) {
    sessionStorage.setItem("userInfo", JSON.stringify(status));
    state.userInfo = status;
  },
  [types.SET_COMPANYINFO](state, status) {
    sessionStorage.setItem("companyInfo", JSON.stringify(status));
    state.companyInfo = status;
  }
};

export default mutations;
